import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setPopupStateChanged, setPopupStateDiff } from '#action/project/devices-popup';
import { getSymmetricDifference, getAlertDiff } from '#component/device/devices-popup/helper';

export const useDevicePopupChangesAppliance = (formDataObj, openedFromForm, formDevicesProp) => {
  const { groupData, formDevices: dataFormDevices } = formDataObj || {};

  const dispatch = useDispatch();
  const popupFormDevices = useSelector(s => s.projectDevicesPopup?.formDevices, shallowEqual);

  const formValues = groupData?.devices || [];
  const formDevices = formDevicesProp || dataFormDevices || popupFormDevices || [];

  const formDevicesJson = JSON.stringify(formDevices);
  const formValuesJson = JSON.stringify(formValues);

  useEffect(() => {
    if (!openedFromForm || !formDevices?.length || !formValues?.length) {
      return;
    }
    const symmetricDiff = getSymmetricDifference(formDevices, formValues) ?? [];
    const alertsDiff = getAlertDiff(formDevices, formValues);
    const isChanged = Boolean(symmetricDiff.length) || Boolean(alertsDiff.length);

    dispatch(setPopupStateChanged(isChanged));
    dispatch(setPopupStateDiff(symmetricDiff));
  }, [dispatch, formDevicesJson, formValuesJson, openedFromForm]);
};
